export enum FollowUpStudyIssuesKind {
	Format = "format",
	Incomplete = "incomplete",
}
